import { showBanner } from './../../template/template.js'
import './style.min.css'

const isFR = document.documentElement.lang == 'fr'

const MAX_PARTICIPANTS = 8
const SPOTS_GET_URL =
    'https://sheets.googleapis.com/v4/spreadsheets/15y_HAfoqwwN0LdR1Xk5kfC1VXB9cJ-KWkrLz6kXVqzM/values/Spots!B4:D4?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE&majorDimension=ROWS'
const SPOTS_POST_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSe06lCLMMnBt_LAHYJAfRFmymIzzE_vzhwdhAdxKVVufTOH2g/formResponse'
const SIGNUP_POST_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScWpMl_ZcGSEQObVvU4eq7ALSWdn7i152CR-zSQw7Dd8-3Z5w/formResponse'

const form = document.querySelector('#sign-up-form')
const addParticipant = document.querySelector('#add-participant')
const eventOptions = [
    document.querySelector('#awareness-hour'),
    document.querySelector('#carnival-walk'),
    document.querySelector('#soccer-tournament'),
]
const submitButton = document.querySelector('#submit-button')
const participantName = document.querySelector('#participant-name')
const participantEmail = document.querySelector('#participant-email')
const eventSelectionLabel = document.querySelector('#event-selection-label')
const teamName = document.querySelector('#team-name')
const teamNameInput = document.querySelector('#team-name-input')
const photoConsent = document.querySelector('#photo-consent')

let numParticipants = 1
let actualNumParticipants = 1

// Add participant name field when user clicks on "Add participant" button
addParticipant.addEventListener('click', () => {
    if (numParticipants >= MAX_PARTICIPANTS) {
        showBanner(`Maximum ${MAX_PARTICIPANTS} participants at once!`, `Maximum ${MAX_PARTICIPANTS} participants à la fois!`, 0)
        return
    }

    // Create new element and insert into form
    let newElement = document.createElement('div')
    numParticipants += 1
    newElement.classList.add('pair')
    newElement.innerHTML = `<label for="participant-${numParticipants}">Participant ${numParticipants} </label>
                            <input class="full-length" type="text" id="participant-${numParticipants}" maxlength="100" placeholder="${
        isFR ? 'Nom complet' : 'Full name'
    }" />`
    form.insertBefore(newElement, addParticipant.parentElement.parentElement)

    // Remove button when maximum is reached
    if (numParticipants === MAX_PARTICIPANTS) addParticipant.style.display = 'none'
})

// Event selection check box
for (let i = 0; i < eventOptions.length; i++) {
    let eventOption = eventOptions[i]
    eventOption.addEventListener('click', () => {
        if (eventOption.full) return
        eventOption.classList.toggle('selected')
        // Add team name option if soccer is selected
        if (i === 2) {
            teamName.classList.toggle('visible')
        }
    })
}

// Update event selection label for number of participants
form.addEventListener('input', () => {
    actualNumParticipants = getOtherParticipants().length + 1
    if (actualNumParticipants > 1)
        eventSelectionLabel.textContent = isFR
            ? `Inscrire tous les ${actualNumParticipants} participants pour `
            : `Sign up all ${actualNumParticipants} participants for `
    else eventSelectionLabel.textContent = isFR ? 'Inscrire pour' : 'Sign up for '
})

// Get number of spots left for each event
function checkFullEvents(url) {
    var xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function () {
        // Check if request is done
        if (xmlHttp.readyState == 4) {
            // Check if request is successful
            if (xmlHttp.status == 200) {
                JSON.parse(xmlHttp.response).values[0].forEach((value, index) => {
                    if (parseInt(value) <= 0) {
                        eventOptions[index].classList.add('full')
                        eventOptions[index].full = true
                    }
                })
            }
            // Wait until the request is done before checking for error
            else {
                eventOptions.forEach((option) => {
                    option.classList.add('full')
                    option.full = true
                })
                showBanner("We couldn't fetch the data, please refresh this page", 'Une erreur est survenue, veuillez rafraîchr la page', 0, 10)
            }
        }
    }
    xmlHttp.open('GET', url, true)
    xmlHttp.send(null)
}
checkFullEvents(SPOTS_GET_URL)

form.addEventListener('submit', (e) => {
    // Avoid double clicks
    submitButton.disabled = true
    form.parentElement.classList.add('disabled')
    e.preventDefault()

    // Check if every field is filled
    validateForm((errorMessage, errorMessageFR) => {
        if (errorMessage.length > 0) {
            submitButton.disabled = false
            form.parentElement.classList.remove('disabled')
            showBanner(errorMessage, errorMessageFR, 0)
            return
        }

        // Post the data to Google Forms
        fetch(SIGNUP_POST_URL, {
            method: 'POST',
            mode: 'no-cors',
            header: {
                'Content-Type': 'application/json',
            },
            body: getInputData(),
        })
            .then(() => {
                // Update spots
                postSpotsUpdate()

                showBanner('Your spots are reserved! :)', 'Vos places ont été réservées! :)')
            })
            .catch((error) => {
                console.error(error)
                submitButton.disabled = false
                showBanner('An unexpected error occurred :(', 'Une erreur est survenue :(', 0)
            })
    })
})

// Returns an error string depending on the field that is missing
function validateForm(submitForm) {
    let errorMessage = ''
    let errorMessageFR = ''
    if (participantName.value.length < 4) {
        errorMessage = 'Please enter your full name.'
        errorMessageFR = 'Veuillez entrer votre nom complet.'
    } else if (!validateEmail(participantEmail.value)) {
        errorMessage = 'Please enter a valid email address.'
        errorMessageFR = 'Veuillez entrer une adresse courriel valide.'
    } else if (!photoConsent.checked) {
        errorMessage = "Photos and videos will be taken during the event. We cannot ensure that you won't appear in any of them. "
        errorMessageFR =
            "Des photos et vidéos seront prises durant l'événement. Nous ne pouvons garantir que vous n'apparaîtrez dans aucun de ceux-ci. "
    } else {
        let selected = document.querySelectorAll('.event-selection .selected')
        if (selected.length <= 0) {
            errorMessage = 'Please select at least one event.'
            errorMessageFR = 'Veuillez sélectionner au moins un événement.'
        } else {
            for (let selectedEvent of selected) {
                if (selectedEvent.full) {
                    errorMessage = 'The event you selected is full.'
                    errorMessageFR = "L'événement sélectionné est complet."
                    selectedEvent.classList.remove('selected')
                }
            }
        }
    }

    submitForm(errorMessage, errorMessageFR)
}
function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

function getInputData() {
    let dataToPost = new FormData()

    let signUp = {
        name: participantName.value,
        email: participantEmail.value,
        sendReminders: document.querySelector('#send-reminders').checked,
        otherParticipants: [],
        attendAwareness: eventOptions[0].classList.contains('selected'),
        attendCarnival: eventOptions[1].classList.contains('selected'),
        attendTournament: eventOptions[2].classList.contains('selected'),
        teamName: eventOptions[2].classList.contains('selected') ? teamNameInput.value : '',
    }

    // Only count participants with names and add to sign-up order
    signUp.otherParticipants = getOtherParticipants()

    dataToPost.append('entry.1606317243', JSON.stringify(signUp))

    return dataToPost
}
function getOtherParticipants() {
    let otherParts = []
    for (let i = 2; i <= numParticipants; i++) {
        let partName = document.querySelector(`#participant-${i}`).value
        if (partName.length > 0) {
            otherParts.push(partName)
        }
    }
    return otherParts
}
function postSpotsUpdate() {
    // Post the data to Google Forms
    fetch(SPOTS_POST_URL, {
        method: 'POST',
        mode: 'no-cors',
        header: {
            'Content-Type': 'application/json',
        },
        body: getSpotsData(),
    })
}
function getSpotsData() {
    let dataToPost = new FormData()
    dataToPost.append('entry.1606317243', eventOptions[0].classList.contains('selected') ? actualNumParticipants : 0)
    dataToPost.append('entry.1876385579', eventOptions[1].classList.contains('selected') ? actualNumParticipants : 0)
    dataToPost.append('entry.1961480877', eventOptions[2].classList.contains('selected') ? actualNumParticipants : 0)
    return dataToPost
}
